import React, { Component } from 'react';

export default class FancyCheckbox extends Component {
	static ids = 1;
	static defaultProps = {
		onChange: () => {
		}
	};

	constructor(props) {
		super(props);
		this.id = `fancy-checkbox${FancyCheckbox.ids++}`;
	}

	render() {
		const { checked, disabled, children, ...props } = this.props;
		return (
			<div className={`bubbly-checkbox ${disabled ? 'disabled' : ''}`}>
				<input className='fancy-checkbox-input' id={this.id} type='checkbox' checked={checked}
				       disabled={disabled} {...props} />
				<label className='fancy-checkbox-label' htmlFor={this.id}>{children}</label>
			</div>
		);
	}
}